import { jsx } from "react/jsx-runtime";
import "react";
import { RealTimeContext } from "./RealTimeContext.js";
const RealTimeProvider = ({ children, value })=>/*#__PURE__*/ jsx(RealTimeContext.Provider, {
        value: value,
        children: children
    });
export { RealTimeProvider };
